<template>
  <!-- Display the formatted date/time for a message -->
  <span class="chat-message-time">{{ prettyData }}</span>
</template>

<script>
const store = require("@/store").default;
export default {
  name: "RelativeTime",
  props: {
    message: Object,
  },
  data: () => ({
    prettyData: null,
  }),
  mounted() {
    this.prettyData = this.time_format(this.message); // format date on mounted
    this.intervalId = setInterval(() => { // set a ticker to update time
      this.prettyData = this.time_format(this.message);
    }, 60000);
  },
  beforeDestroy() {
    clearInterval(this.intervalId); // clear the ticker for memory management
  },
  methods: {
    /**
     * Checks if the given date is yesterday.
     *
     * @param {Date} date - The date to check.
     * @returns {boolean} - `true` if the date is yesterday, `false` otherwise.
     */
    isYesterday(date) {
      const today = new Date();
      const yesterday = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
      return (
        date.getDate() == yesterday.getDate() &&
        date.getMonth() == yesterday.getMonth() &&
        date.getFullYear() == yesterday.getFullYear()
      );
    },

    /**
     * Formats the given message timestamp into a relative time string.
     *
     * @param {Object} msg - The message object containing the timestamp.
     * @param {string} msg.sent_at - The timestamp of the message.
     * @param {string} msg.sender_type - The type of the message sender, ENUM("user", "bot").
     * @returns {string} - The formatted relative time string.
     */
    time_format(msg) {
      const time = msg.sent_at;

      // Options for date formatting without specific time
      const dateOptions = {
        weekday: "short", year: "numeric", month: "short", day: "numeric"
      };

      // Options for time formatting
      const timeOptions = {
        hour: "numeric", minute: "numeric", hour12: true
      };

      // Check if the message time is undefined, null, empty, or from the bot
      if (time === undefined || time === null || time === "" || msg.sender_type === "bot") return "";

      const now = new Date();
      const messageTime = new Date(time);
      const diffInSeconds = Math.round((now - messageTime) / 1000);

      // Return relative time strings based on the time difference
      if (diffInSeconds < 60) {
        return store.state.user.lang === "en" ? "just now" : "à l'instant";
      } else if (diffInSeconds < 3600) { // Less than an hour
        const minutes = Math.floor(diffInSeconds / 60);
        const minutesText = store.state.user.lang === "en" ? " minutes ago" : " il y a " + minutes + " minutes";
        return minutes > 1 ? minutes + minutesText : store.state.user.lang === "en" ? "a minute ago" : "il y a une minute";
      } else if (diffInSeconds < 86400 && messageTime.toLocaleDateString() === now.toLocaleDateString()) { // Same day
        return store.state.user.lang === "en" ? "today at " + messageTime.toLocaleTimeString("en-US", timeOptions)
          : "aujourd'hui à " + messageTime.toLocaleTimeString("fr-FR", timeOptions);
      } else if (this.isYesterday(messageTime)) { // Yesterday
        return store.state.user.lang === "en" ? "yesterday" : "hier";
      } else if (diffInSeconds < 31536000) { // Within the last year
        return messageTime.toLocaleDateString(store.state.user.lang == "fr" ? "fr-FR" : "en-US", dateOptions);
      } else { // More than a year ago
        return store.state.user.lang === "en" ? "over a year ago" : "il y a plus d'un an";
      }
    },
  }
};
</script>
